<!--
CREATE TABLE `merchant_info` (
  `id` int(10) unsigned NOT NULL AUTO_INCREMENT COMMENT '序号（主键）',
  `group_main_merchant_no` varchar(30) COMMENT '集团主商户号',
  `group_main_merchant` varchar(100) COMMENT '集团主商户',
  `province` varchar(20) COMMENT '省份',
  `city` varchar(20) COMMENT '城市',
  `merchant_id_no` varchar(30) COMMENT '商户身份号',
  `second_group_merchant_no` varchar(30) COMMENT '二级集团商家号',
  `wechat_second_no` varchar(30) COMMENT '微信二级号',
  `wechat_second_auth_status` varchar(20) COMMENT '微信二级号认证状态',
  `alipay_second_no` varchar(30) COMMENT '支付宝二级号',
  `alipay_second_auth_status` varchar(20) COMMENT '支付宝二级号认证状态',
  `second_group_merchant_name` varchar(100) COMMENT '二级集团商户名称',
  `legal_person` varchar(20) COMMENT '法人',
  `second_group_merchant_phone` varchar(15) COMMENT '二级集团商户联系电话',
  `third_merchant_no` varchar(30) COMMENT '三级商户号',
  `third_wechat_second_no` varchar(30) COMMENT '三级商户-微信二级号',
  `third_wechat_second_auth_status` varchar(20) COMMENT '三级商户-微信二级号认证状态',
  `third_alipay_second_no` varchar(30) COMMENT '三级商户-支付宝二级号',
  `third_alipay_second_auth_status` varchar(20) COMMENT '三级商户-支付宝二级号认证状态',
  `third_merchant_project_name` varchar(100) COMMENT '三级商户号对外项目名称',
  `merchant_contact` varchar(20) COMMENT '商户联系人',
  `third_merchant_phone` varchar(15) COMMENT '三级商户号联系电话',
  `registered_address` varchar(255) COMMENT '注册地址',
  `pos_terminal_no` varchar(30) COMMENT 'POS机终端编号',
  `terminal_no` varchar(30) NOT NULL COMMENT '终端号',
  PRIMARY KEY (`id`,`terminal_no`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci COMMENT='商户信息表';
-->
<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.second_group_merchant_name" placeholder="二级集团商户名称" size="mini" style="width:200px" />
      <el-input v-model="query.third_merchant_no" placeholder="三级商户号" size="mini" style="width:200px" />
      <el-input v-model="query.terminal_no" placeholder="终端号" size="mini" style="width:200px" />
      <el-button type="primary" @click="getList" size="mini">搜索</el-button>
      <el-button type="success" @click="handleAdd" size="mini" icon="el-icon-plus">新增</el-button>
      <el-button type="primary" @click="importExcel" size="mini">导入</el-button>
      <el-button type="primary" @click="infoToSecond" size="mini">提取组织</el-button>
      <el-button type="primary" @click="makeLevel" size="mini">构建层级</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="70" fixed />
      <el-table-column prop="group_main_merchant_no" label="集团主商户号" width="150" show-overflow-tooltip />
      <el-table-column prop="group_main_merchant" label="集团主商户" width="150" show-overflow-tooltip />
      <el-table-column prop="province" label="省份" width="120" />
      <el-table-column prop="city" label="城市" width="80" />
      <el-table-column prop="merchant_id_no" label="商户身份号" width="130" show-overflow-tooltip />
      <el-table-column prop="second_group_merchant_no" label="二级集团商家号" width="150" show-overflow-tooltip />
      <el-table-column prop="second_group_merchant_name" label="二级集团商户名称" width="160" show-overflow-tooltip />
      <el-table-column prop="legal_person" label="法人" width="80" />
      <el-table-column prop="second_group_merchant_phone" label="二级集团商户电话" width="140" />
      <el-table-column prop="wechat_second_no" label="微信二级号" width="130" show-overflow-tooltip />
      <el-table-column prop="wechat_second_auth_status" label="微信二级认证状态" width="140" />
      <el-table-column prop="alipay_second_no" label="支付宝二级号" width="130" show-overflow-tooltip />
      <el-table-column prop="alipay_second_auth_status" label="支付宝二级认证状态" width="140" />
      <el-table-column prop="third_merchant_no" label="三级商户号" width="130" show-overflow-tooltip />
      <el-table-column prop="third_merchant_project_name" label="三级商户项目名称" width="160" show-overflow-tooltip />
      <el-table-column prop="merchant_contact" label="商户联系人" width="100" />
      <el-table-column prop="third_merchant_phone" label="三级商户电话" width="130" />
      <el-table-column prop="third_wechat_second_no" label="三级微信二级号" width="130" show-overflow-tooltip />
      <el-table-column prop="third_wechat_second_auth_status" label="三级微信认证状态" width="140" />
      <el-table-column prop="third_alipay_second_no" label="三级支付宝二级号" width="140" show-overflow-tooltip />
      <el-table-column prop="third_alipay_second_auth_status" label="三级支付宝认证状态" width="150" />
      <el-table-column prop="registered_address" label="注册地址" width="180" show-overflow-tooltip />
      <el-table-column prop="pos_terminal_no" label="POS机终端编号" width="130" show-overflow-tooltip />
      <el-table-column prop="terminal_no" label="终端号" width="100" />
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next,sizes"
      :total="pageData.total"
      :page-sizes="[10, 20, 50, 100]"
      style="margin-top:15px;text-align:right"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :visible.sync="dialogVisible" :title="form.id ? '编辑商户信息' : '新增商户信息'" width="750px" top="5vh">
      <el-form :model="form" label-width="150px" size="mini">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="集团主商户号">
              <el-input v-model="form.group_main_merchant_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="集团主商户">
              <el-input v-model="form.group_main_merchant" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省份">
              <el-input v-model="form.province" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="城市">
              <el-input v-model="form.city" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户身份号">
              <el-input v-model="form.merchant_id_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级集团商家号">
              <el-input v-model="form.second_group_merchant_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级集团商户名称">
              <el-input v-model="form.second_group_merchant_name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人">
              <el-input v-model="form.legal_person" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级集团商户电话">
              <el-input v-model="form.second_group_merchant_phone" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信二级号">
              <el-input v-model="form.wechat_second_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信二级认证状态">
              <el-input v-model="form.wechat_second_auth_status" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付宝二级号">
              <el-input v-model="form.alipay_second_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付宝二级认证状态">
              <el-input v-model="form.alipay_second_auth_status" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三级商户号">
              <el-input v-model="form.third_merchant_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三级商户项目名称">
              <el-input v-model="form.third_merchant_project_name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户联系人">
              <el-input v-model="form.merchant_contact" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三级商户电话">
              <el-input v-model="form.third_merchant_phone" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三级微信二级号">
              <el-input v-model="form.third_wechat_second_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三级微信认证状态">
              <el-input v-model="form.third_wechat_second_auth_status" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三级支付宝二级号">
              <el-input v-model="form.third_alipay_second_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三级支付宝认证状态">
              <el-input v-model="form.third_alipay_second_auth_status" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="注册地址">
              <el-input v-model="form.registered_address" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="POS机终端编号">
              <el-input v-model="form.pos_terminal_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终端号">
              <el-input v-model="form.terminal_no" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'MerchantInfo',
  data() {
    return {
      query: {
        second_group_merchant_name: "",
        third_merchant_no: "",
        terminal_no: "",
      },
      pageData: {
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const params = Params.ins()
        .where(this.query.second_group_merchant_name ? ['second_group_merchant_name', 'like', '%' + this.query.second_group_merchant_name + '%'] : null)
        .where(this.query.third_merchant_no ? ['third_merchant_no', '=', this.query.third_merchant_no] : null)
        .where(this.query.terminal_no ? ['terminal_no', '=', this.query.terminal_no] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('MerchantInfo/index', params, res => {
        if (res.code === 200) {
          this.pageData = res.data
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },

    // 新增
    handleAdd() {
      this.form = {}
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.form = { ...row }
      this.dialogVisible = true
    },

    // 提交保存
    submit() {
      Http.post('MerchantInfo/save', Params.ins().save(this.form), res => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 删除
    handleDelete(id) {
      this.$confirm('确定删除该记录？', '提示', { type: 'warning' }).then(() => {
        Http.post('MerchantInfo/delete', Params.ins().delete(id), res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },

    importExcel(){
      const that=this;
      Http.upload("MerchantInfo/uploadFile",data=>{
        Http.post('MerchantInfo/importExcel',{path:data.path},res=>{
          if(res.code===200){
            that.$message.success('导入成功')
            that.getList()
          }else{
            that.$message.error(res.msg)
          }
        })
      })
    },
    infoToSecond(){
      const that=this;
      Http.post('MerchantInfo/infoToSecond',{},res=>{
        if(res.code===200){
          that.$message.success('详情提取分公司成功')
        }else{
          that.$message.error(res.msg)
        }
      })
    },
    makeLevel(){
      const that=this;
      Http.post('MerchantInfo/makeLevel',{},res=>{
        if(res.code===200){
          that.$message.success('生成层级关系成功')
        }else{
          that.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body {
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/PosDevice/MerchantInfo.vue